import "./landing.css";
import Button from "../../../components/Button/Button";
import inchcapeLogoFill from "../../../assets/images/inchcape-logo-fill.svg";
import fetchClient from "../../../services/fetch"

const Landing = () => {
  const handleLogin = () => {
    fetchClient()
      .get("/sso")
      .then((response) => {
        const path = response.data
        if (path) {
          window.location.href = path;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="landing-main">
      <div className="landing-container">
        <img src={inchcapeLogoFill} alt="Inchcape Logo" />
        <div>
          <h1>Test Drive</h1>
          <Button onClick={handleLogin} type="primary" children="Login" className="landing-login-button" />
        </div>
      </div>
    </div>
  );
};

export default Landing;
